// src/models/leadTypes.js

export const LEAD_SOURCES = {
  HOME_PAGE_AUTO: 'HOME_PAGE_AUTO',
  EXIT_INTENT: 'EXIT_INTENT',
  WHATSAPP_FLOAT: 'WHATSAPP_FLOAT',
  PROPERTY_ENQUIRY: 'PROPERTY_ENQUIRY',
  CONSTRUCTION_QUOTE: 'CONSTRUCTION_QUOTE',
  BUILDER_JOIN: 'BUILDER_JOIN',
  BROKER_JOIN: 'BROKER_JOIN',
  MOBILE_STICKY: 'MOBILE_STICKY',
  DOWNLOAD_BROCHURE: 'DOWNLOAD_BROCHURE',
  NEWSLETTER: 'NEWSLETTER',
};

export const LEAD_TYPES = {
  BUYER: 'Buyer Lead',
  SELLER: 'Seller Lead',
  BUILDER: 'Builder Lead',
  BROKER: 'Broker Lead',
  CONSTRUCTION: 'Construction Lead',
  NEWSLETTER: 'Newsletter Subscriber',
};

export const LEAD_STATUS = {
  NEW: 'New',
  CONTACTED: 'Contacted',
  QUALIFIED: 'Qualified',
  CONVERTED: 'Converted',
  LOST: 'Lost',
};

// Simple schema definition for reference
export const leadSchema = {
  id: String,
  name: String,
  mobile: String,
  city: String,
  requirement: String,
  source: String, // LEAD_SOURCES
  type: String, // LEAD_TYPES
  status: String, // LEAD_STATUS
  propertyInterest: String, // Optional
  createdAt: Date,
};
